import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { useMemo } from "react";
import Skeleton from "react-loading-skeleton";

import { TextTooltip } from "@transfr-inc/dashboard-components";
import { ToggleButton } from "@transfr-inc/dashboard-components/forms";

import "./toggle.field.scss";

export const ToggleField = ({
  className,
  label,
  description,
  value,
  onChange,
  children,
  required,
  loading,
  disabled,
}) => {
  const fieldHeader = useMemo(() => {
    return (
      <h3 className="toggle-field-header">
        {label}
        {description && (
          <TextTooltip theme="form-info" text={description}>
            <FontAwesomeIcon icon={"far fa-circle-info"} />
          </TextTooltip>
        )}
        {required && <span className="required-indicator">*</span>}
      </h3>
    );
  }, [label, description, required]);

  const childrenContent = useMemo(() => {
    if (children) {
      return loading ? (
        <div className="tx-skeleton-container">
          <Skeleton rounded height="1.875rem" width="100%" />
        </div>
      ) : (
        children
      );
    }

    return;
  }, [children, loading]);

  return (
    <div className={clsx("toggle-field", className)}>
      {fieldHeader}
      <div className="toggle-field-content">
        {loading ? (
          <Skeleton rounded height="1.875rem" width="5rem" />
        ) : (
          <ToggleButton
            id="toggle-field"
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
        )}
        {childrenContent}
      </div>
    </div>
  );
};
